export function string(val: unknown): string {
  return String(val);
}

export function array<T>(val: string, valueParser: (val: unknown) => T): T[] {
  return val.split(',').map(item => valueParser(item.trim()));
}

export function boolean(val: unknown): boolean {
  const str = String(val).toLowerCase();
  return str === 'true' || str === '1';
}
